import { render } from "./OrderStatusEditPage.vue?vue&type=template&id=75df6dce"
import script from "./OrderStatusEditPage.vue?vue&type=script&lang=js"
export * from "./OrderStatusEditPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__